import { ApiProperty } from "@nestjs/swagger";
import { SubJobRevisionCodesRequest } from "./sub-job-revision-codes-req";

export class SubJobReviseReq{
    @ApiProperty()
    traceCodesData: SubJobRevisionCodesRequest[];
    @ApiProperty()
    createdUser:string

}